<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M8.33301 5.00065C6.95217 5.00065 5.83301 5.74648 5.83301 6.66732C5.83301 7.58815 6.95217 8.33398 8.33301 8.33398C9.71384 8.33398 10.833 9.07982 10.833 10.0007C10.833 10.9215 9.71384 11.6673 8.33301 11.6673M8.33301 5.00065C9.25801 5.00065 10.0663 5.33565 10.4988 5.83398M8.33301 5.00065V4.16732M8.33301 5.00065V11.6673M8.33301 11.6673V12.5007M8.33301 11.6673C7.40801 11.6673 6.59967 11.3323 6.16717 10.834M15.833 8.33398C15.833 9.3189 15.639 10.2942 15.2621 11.2041C14.8852 12.1141 14.3327 12.9408 13.6363 13.6373C12.9399 14.3337 12.1131 14.8862 11.2031 15.2631C10.2932 15.64 9.31792 15.834 8.33301 15.834C7.34809 15.834 6.37282 15.64 5.46288 15.2631C4.55294 14.8862 3.72615 14.3337 3.02971 13.6373C2.33327 12.9408 1.78082 12.1141 1.40391 11.2041C1.027 10.2942 0.833008 9.3189 0.833008 8.33398C0.833008 6.34486 1.62318 4.43721 3.02971 3.03068C4.43623 1.62416 6.34388 0.833984 8.33301 0.833984C10.3221 0.833984 12.2298 1.62416 13.6363 3.03068C15.0428 4.43721 15.833 6.34486 15.833 8.33398Z"
      stroke="currentColor"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
